import { render, staticRenderFns } from "./HTMLContent.vue?vue&type=template&id=24b6abbf"
import script from "./HTMLContent.vue?vue&type=script&lang=js"
export * from "./HTMLContent.vue?vue&type=script&lang=js"
import style0 from "./HTMLContent.vue?vue&type=style&index=0&id=24b6abbf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports